import { createWsActions, WsPrefixes, send } from '@skynet/data-ws-core';
import type { WsCommand } from '@skynet/data-ws-core';

export const prefix = WsPrefixes.smmPrefix;

const smmActions = createWsActions(prefix);

export const {
  actionConnect: actionSmmConnect,
  actionOnOpen: actionSmmOnOpen,
  actionDisconnect: actionSmmDisconnect,
  actionOnClose: actionSmmOnClose,
  actionOnClosed: actionSmmOnClosed,
  actionSend: actionSmmSend,
  actionOnMessage: actionSmmOnMessage,
  actionOnBroken: actionSmmOnBroken,
  actionOnReconnectBegin: actionSmmOnReconnectBegin,
  actionOnReconnectAttempt: actionSmmOnReconnectAttempt,
  actionOnReconnected: actionSmmOnReconnected,
  actionOnError: actionSmmOnError,
} = smmActions;

export { smmActions };

/** Dispatches a WS send action with the SMM prefix. */
export const wsSmmSend = (message: WsCommand) => send(message, prefix);
